document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.prc-container');
  if (!container) return;

  const currency = container.dataset.currency || 'EUR';
  const locale = container.dataset.locale || 'es-ES';
  const variants = JSON.parse(container.dataset.variants || '[]');
  const priceDisplays = document.querySelectorAll('.prc-price');
  const KLAVIYO_BIS_FORM = 'R8Kaz2';
  const LOW_STOCK_THRESHOLD = 3;

  function formatMoney(cents) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  // ── SIZE BUTTONS ──
  const sizeBtns = Array.from(container.querySelectorAll('.prc-size-btn'));
  const desktopVariantInput = document.querySelector('.prc-variant-input-desktop');
  const ctaSingle = document.querySelector('.prc-cta-single');
  const ctaSplit = document.querySelector('.prc-cta-split');
  const selectedOptions = {};

  const allOptionIndexes = [...new Set(sizeBtns.map(b => parseInt(b.dataset.optionIndex, 10)))];
  const isBundle = allOptionIndexes.length > 1;

  function isVariantAvailable(v) {
    if (typeof v.available === 'boolean') return v.available;
    if (typeof v.availableForSale === 'boolean') return v.availableForSale;
    return false;
  }

  function getVariantInventory(v) {
    return v.inventory_quantity ?? v.inventoryQuantity ?? 0;
  }

  // Solo comparamos los indices que realmente corresponden a grupos de talla (allOptionIndexes),
  // ignorando cualquier opcion adicional o slot que Shopify pueda rellenar internamente.
  function findVariant(opts) {
    return variants.find(v => allOptionIndexes.every(i => v.options[i] === opts[i])) || null;
  }

  // ── Disponibilidad por boton de talla ──
  // Productos normales (1 grupo): exacto por variante.
  // Productos bundle (2+ grupos independientes): cada talla se evalua de forma INDEPENDIENTE,
  // sin que la seleccion de un grupo contamine al otro. Se tacha solo si NINGUNA combinacion
  // posible con esa talla esta disponible.
  function isButtonAvailable(btn) {
    const idx = parseInt(btn.dataset.optionIndex, 10);
    const val = btn.dataset.optionValue;

    if (!isBundle) {
      const v = findVariant({ [idx]: val });
      return { available: v ? isVariantAvailable(v) : false, variant: v };
    }

    const candidates = variants.filter(v => v.options[idx] === val);
    const anyAvailable = candidates.find(v => isVariantAvailable(v));
    return { available: !!anyAvailable, variant: anyAvailable || candidates[0] || null };
  }

  function refreshSizeButtonsAvailability() {
    sizeBtns.forEach(btn => {
      const { available, variant } = isButtonAvailable(btn);
      btn.classList.toggle('sold-out', !available);
      if (variant) btn.dataset.inventory = getVariantInventory(variant);
      const inv = variant ? getVariantInventory(variant) : 0;
      btn.classList.toggle('low-stock', available && inv > 0 && inv <= LOW_STOCK_THRESHOLD);
    });
  }

  // ── STOCK STATUS ──
  function updateStockStatus(variant, btn) {
    const el = document.getElementById('prc-stock-status');
    if (!el) return;
    if (!variant || !isVariantAvailable(variant)) {
      el.textContent = 'Agotado'; el.className = 'prc-stock-status out-of-stock'; return;
    }
    const inv = parseInt(btn?.dataset.inventory, 10) || getVariantInventory(variant) || 0;
    if (inv > 0 && inv <= LOW_STOCK_THRESHOLD) {
      el.textContent = 'Pocas unidades'; el.className = 'prc-stock-status low-stock';
    } else {
      el.textContent = ''; el.className = 'prc-stock-status';
    }
  }

  // ── KLAVIYO BIS ── (solo se usa en productos simples, nunca en bundles)
  window.prcOpenBIS = function(variantId) {
    window.klaviyoVariantId = variantId;
    window._klBISVariantId = variantId;
    function tryOpen() {
      if (window._klOnsite?.openForm) { window._klOnsite.openForm(KLAVIYO_BIS_FORM); return true; }
      if (window.klaviyo?.openForm) { window.klaviyo.openForm(KLAVIYO_BIS_FORM); return true; }
      return false;
    }
    if (!tryOpen()) {
      var attempts = 0;
      var iv = setInterval(function() { if (tryOpen() || ++attempts > 20) clearInterval(iv); }, 300);
    }
  };

  // ── NOTIFY (solo productos simples) ──
  function showNotify(variant) {
    document.querySelector('.prc-cta-single')?.style.setProperty('display', 'none');
    document.querySelector('.prc-cta-split')?.style.setProperty('display', 'none');
    let wrap = document.getElementById('prc-notify-wrap');
    if (!wrap) {
      wrap = document.createElement('div'); wrap.id = 'prc-notify-wrap';
      document.getElementById('prc-cta-block')?.appendChild(wrap);
    }
    wrap.innerHTML = `<button class="prc-notify-btn" type="button" onclick="window.prcOpenBIS('${variant.id}')">
      &#128276; Av&iacute;same cuando est&eacute; disponible
    </button><p class="prc-notify-label">Talla agotada</p>`;
    wrap.style.display = 'block';
  }
  function hideNotify() {
    const w = document.getElementById('prc-notify-wrap');
    if (w) w.style.display = 'none';
  }

  // En bundles: mostrar el placeholder "Selecciona una talla" en vez de notify,
  // para evitar falsos positivos por contaminacion cruzada entre grupos de talla.
  function showSelectPlaceholder(text) {
    hideNotify();
    if (ctaSplit) ctaSplit.style.display = 'none';
    if (ctaSingle) {
      ctaSingle.style.display = 'block';
      const placeholderBtn = ctaSingle.querySelector('.prc-cta-placeholder');
      if (placeholderBtn) placeholderBtn.textContent = text;
    }
  }

  // ── BOTON STICKY MOBILE "ELEGIR TALLA" ──
  (function initChooseSizeButton() {
    if (window.innerWidth > 768) return;
    const footer = document.getElementById('prc-mobile-footer');
    const chooseBtn = document.getElementById('prc-footer-choose-size-btn');
    const sizesSection = document.getElementById('prc-sizes-section');
    if (!footer || !chooseBtn || !sizesSection) return;

    chooseBtn.addEventListener('click', function() {
      sizesSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      footer.classList.add('is-hidden');
    });

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          footer.classList.add('is-hidden');
          observer.disconnect();
        }
      });
    }, { threshold: 0.5 });
    observer.observe(sizesSection);
  })();

  function updateCTA(variant, activeBtn) {
    updateStockStatus(variant, activeBtn);

    if (isBundle) {
      // En bundles nunca mostramos notify; si la combinacion no existe o no esta disponible,
      // mostramos el placeholder de seleccion para evitar falsos positivos cruzados.
      if (!variant || !isVariantAvailable(variant)) {
        showSelectPlaceholder('Combinación no disponible');
        return;
      }
      hideNotify();
      const price = formatMoney(variant.price);
      priceDisplays.forEach(el => el.textContent = price);
      if (desktopVariantInput) desktopVariantInput.value = variant.id;
      if (ctaSingle) ctaSingle.style.display = 'none';
      if (ctaSplit) ctaSplit.style.display = 'flex';
      return;
    }

    // Producto simple: comportamiento normal con notify
    hideNotify();
    if (!variant) {
      showSelectPlaceholder('Selecciona una talla');
      return;
    }

    const price = formatMoney(variant.price);
    priceDisplays.forEach(el => el.textContent = price);
    if (desktopVariantInput) desktopVariantInput.value = variant.id;

    if (isVariantAvailable(variant)) {
      if (ctaSingle) ctaSingle.style.display = 'none';
      if (ctaSplit) ctaSplit.style.display = 'flex';
    } else {
      if (ctaSingle) ctaSingle.style.display = 'none';
      if (ctaSplit) ctaSplit.style.display = 'none';
      showNotify(variant);
    }
  }

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const idx = parseInt(this.dataset.optionIndex, 10);
      sizeBtns.forEach(b => { if (parseInt(b.dataset.optionIndex, 10) === idx) b.classList.remove('active'); });
      this.classList.add('active');
      selectedOptions[idx] = this.dataset.optionValue;

      refreshSizeButtonsAvailability();

      const variant = findVariant(selectedOptions);
      updateCTA(variant, this);
    });
  });

  // Preseleccionar primera talla disponible por grupo
  refreshSizeButtonsAvailability();
  allOptionIndexes.forEach(idx => {
    const btn = container.querySelector(`.prc-size-btn[data-option-index="${idx}"]:not(.sold-out)`) || container.querySelector(`.prc-size-btn[data-option-index="${idx}"]`);
    if (btn) { btn.classList.add('active'); selectedOptions[idx] = btn.dataset.optionValue; }
  });
  refreshSizeButtonsAvailability();
  updateCTA(findVariant(selectedOptions), container.querySelector('.prc-size-btn.active'));

  // ── FORM (compartido desktop/mobile) ──
  const formDesktop = document.querySelector('.prc-form-desktop');
  if (formDesktop) {
    formDesktop.addEventListener('submit', e => { e.preventDefault(); addToCartAjax(desktopVariantInput?.value); });
  }

  // ── POPUP (tabs) ──
  const popupOverlay = document.getElementById('prc-popup');
  const popupTitle = document.getElementById('prc-popup-title');
  const popupBody = document.getElementById('prc-popup-body');
  const popupContent = {
    'details':  { title: 'Detalles',       body: container.dataset.details  || '' },
    'size-fit': { title: 'Guía de tallas', body: container.dataset.sizeFit  || '' },
    'shipping': { title: 'Envíos',         body: container.dataset.shipping || '' }
  };

  // Cierre centralizado: garantiza que el overflow del body SIEMPRE se restaura.
  // Si esto no ocurre, la pagina entera se queda sin scroll.
  function closePopup() {
    popupOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  container.querySelectorAll('.prc-tab').forEach(tab => {
    tab.addEventListener('click', function() {
      const content = popupContent[this.dataset.tab];
      if (!content) return;
      popupTitle.textContent = content.title;
      popupBody.innerHTML = content.body;
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });
  document.getElementById('prc-popup-close')?.addEventListener('click', closePopup);
  popupOverlay?.addEventListener('click', e => { if (e.target === popupOverlay) closePopup(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });
  // Red de seguridad: al volver con el boton atras el body no debe quedar bloqueado.
  window.addEventListener('pageshow', () => { if (!popupOverlay?.classList.contains('active')) document.body.style.overflow = ''; });

  // ── GUIA DE TALLAS JUNTO AL SELECTOR ──
  // La guia estaba escondida en la fila de tabs, muy por debajo del selector.
  // La subimos a la propia cabecera de tallas y ocultamos el tab duplicado.
  (function initInlineSizeGuide() {
    const labelRow = container.querySelector('.prc-size-label-row');
    const sizeFitTab = container.querySelector('.prc-tab[data-tab="size-fit"]');
    const hasContent = (container.dataset.sizeFit || '').trim().length > 0;
    if (!labelRow || !sizeFitTab || !hasContent) return;

    const style = document.createElement('style');
    style.textContent = `
      .prc-size-guide-inline {
        background: none; border: none; padding: 0; margin: 0 0 0 auto;
        font-family: inherit; font-size: 11px; text-transform: uppercase;
        letter-spacing: 0.8px; color: #8A8A8A; cursor: pointer;
        display: inline-flex; align-items: center; gap: 5px;
        border-bottom: 1px solid #D6CFC4; border-radius: 0;
        transition: color 0.2s ease, border-color 0.2s ease;
      }
      .prc-size-guide-inline:hover { color: #C2A572; border-bottom-color: #C2A572; }
      .prc-size-guide-inline svg { flex-shrink: 0; }
      .prc-size-label-row .prc-stock-status { margin-left: 12px; }
      @media (max-width: 768px) { .prc-size-guide-inline { font-size: 9.5px; } }
    `;
    document.head.appendChild(style);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prc-size-guide-inline';
    btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 14l12-12 8 8-12 12z"/><path d="M7 7l2 2"/><path d="M11 3l2 2"/><path d="M4 11l2 2"/></svg>Gu&iacute;a de tallas';
    btn.addEventListener('click', () => sizeFitTab.click());

    const stock = labelRow.querySelector('.prc-stock-status');
    if (stock) labelRow.insertBefore(btn, stock);
    else labelRow.appendChild(btn);

    sizeFitTab.style.display = 'none';
  })();

  // ── CAROUSEL ──
  const track = container.querySelector('.prc-carousel-track');
  const dots = container.querySelectorAll('.prc-dot');
  if (track && dots.length) {
    let currentIdx = 0, startX = 0, startY = 0, dragging = false;
    track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    track.addEventListener('touchmove', e => {
      if (!dragging) return;
      const dx = startX - e.touches[0].clientX;
      const dy = startY - e.touches[0].clientY;
      // Si el gesto es predominantemente vertical, es scroll de pagina: soltamos el swipe
      // y dejamos que el navegador desplace normalmente.
      if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
      if (Math.abs(dx) > 50) { currentIdx = dx > 0 ? Math.min(currentIdx+1, dots.length-1) : Math.max(currentIdx-1, 0); updateCarousel(); dragging = false; }
    }, { passive: true });
    track.addEventListener('touchend', () => { dragging = false; });
    track.addEventListener('touchcancel', () => { dragging = false; });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { currentIdx = i; updateCarousel(); }));
    container.querySelector('.prc-carousel-prev')?.addEventListener('click', () => { currentIdx = Math.max(currentIdx-1, 0); updateCarousel(); });
    container.querySelector('.prc-carousel-next')?.addEventListener('click', () => { currentIdx = Math.min(currentIdx+1, dots.length-1); updateCarousel(); });
    function updateCarousel() {
      track.style.transform = `translateX(-${currentIdx * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === currentIdx));
    }
  }

  // ── CART ──
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
      el.classList.remove('hidden');
    });
  }

  // RBC 20-ago-2026: /cart/add.js NO devuelve item_count -- devuelve la linea añadida
  // (id, quantity, variant_id, title, price...). La condicion antigua
  // `if (data.item_count !== undefined)` era SIEMPRE falsa, asi que el contador del icono
  // no se refrescaba nunca y habia que recargar la pagina para verlo.
  // Ahora pedimos tambien la seccion cart-icon-bubble y la reemplazamos; si no llegara,
  // caemos a /cart.js para leer el item_count real.
  function refreshCartBubble(sections) {
    const target = document.getElementById('cart-icon-bubble');
    const html = sections && sections['cart-icon-bubble'];
    if (target && html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (fresh) { target.innerHTML = fresh.innerHTML; return; }
    }
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(err => console.error('PRC bubble error:', err));
  }

  function addToCartAjax(variantId) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
    .then(r => r.json())
    .then(data => {
      if (data.sections?.['cart-drawer']) {
        const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        const nD = doc.getElementById('CartDrawer'), cD = document.getElementById('CartDrawer');
        if (nD && cD) cD.innerHTML = nD.innerHTML;
        else { const n = doc.querySelector('cart-drawer'), c = document.querySelector('cart-drawer'); if (n && c) c.innerHTML = n.innerHTML; }
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) { drawerEl.classList.remove('is-empty'); drawerEl.open(); }
        document.querySelector('.drawer__inner')?.classList.remove('is-empty');
      }
      refreshCartBubble(data.sections);
    })
    .catch(err => console.error('PRC cart error:', err));
  }
});
